import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import client from 'api'

const initialState = {
    objects: [],
    status: 'idle',
    error: undefined as (string | undefined),
}

export const loadObjects = createAsyncThunk('objects/LoadObjects', async () => {
    const res = await client.get('/api/ixweb/obj/')
    return res.data
})

const objectsSlice = createSlice({
    name: 'objects',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(loadObjects.pending, (state) => {
            state.status = 'pending'
            state.error = undefined
        })

        builder.addCase(loadObjects.fulfilled, (state, action) => {
            state.status = 'idle'
            state.objects = action.payload
        })

        builder.addCase(loadObjects.rejected, (state, action) => {
            state.status = 'error'
            state.error = action.error.message
        })
    }
})

export default objectsSlice.reducer
